// src/components/plan/planNav.js
// Pooled inbox SP5 — the plan screens' addresses (the server's routeFor for
// `plan` and `payment`, B1) and the one thing every billing action does after
// the server answers.
import { useCallback } from "react";
import { useAuth } from "../../context/AuthContext.jsx";
import { getProfile } from "../../shared/_services/common.services";
import { readCurrentUser } from "../../shared/_helpers/currentUser";

export const PLAN_PATH = "/plan";
export const PLAN_PAYMENT_PATH = "/plan/payment";
export const PLAN_STARTED_PATH = "/plan/started";
export const PLAN_CARD_PATH = "/plan/card";

// Legacy screens (booking, the dashboard's figures) still read the stored
// user's plan fields, which the server rewrites on every billing action. One
// profile re-read merged into the stored copy keeps them in step — merged,
// not replaced, as the legacy purchase did (GET /users/:id is the public
// projection, a subset of the stored object).
export async function refreshStoredUser() {
  const stored = readCurrentUser();
  if (!stored?.user?._id) return;
  const res = await getProfile(stored.user._id);
  if (res?.status !== 200 || !res.data?.data?.user) return;
  const latest = readCurrentUser() || stored;
  Object.assign(latest.user, res.data.data.user);
  localStorage.setItem("currentUser", JSON.stringify(latest));
}

// After start-trial, cancel, a plan change or a new card: the server's
// entitlement becomes the app's at once (the rail and the header flip with no
// reload, R244), then the stored copy is re-read.
export function useBillingResult() {
  const { updateEntitlement } = useAuth();
  return useCallback(
    async (entitlement) => {
      updateEntitlement(entitlement);
      await refreshStoredUser();
    },
    [updateEntitlement],
  );
}
